<template>
    <v-container>
        <v-card class="pl-10 pr-10">
            <v-card-title>
                <b>รายการข้อมูลใบแจ้งหนี้</b>
                <v-spacer></v-spacer>
                <v-spacer></v-spacer>
                <v-spacer></v-spacer>
                <UserBranchDropdown :pageCode="pageCode" @onUserBranchChange='setCurrentBranch'></UserBranchDropdown>
            </v-card-title>
            <v-divider
                class="mx-4"
                inset
                style="padding-top:10px;"
                ></v-divider>
            <v-data-table
            :headers="headers"
                :items-per-page="5"
                :items="items"
                :search="filter"
            >
             <template v-slot:top >
                    <v-toolbar flat color="white">
                        <v-text-field
                            autofocus
                            v-model="filter"
                            append-icon="mdi-magnify"
                            label="ค้นหา"
                            single-line
                            hide-details
                        ></v-text-field><v-spacer></v-spacer><v-spacer></v-spacer>
                    </v-toolbar>
                </template>
            <template v-slot:item.action="{ item }">
                    <JobInvoice :data='item'></JobInvoice>
                </template>
            </v-data-table>
        </v-card>
    </v-container>
</template>

<script>

import {listJobInvoice} from '@/api/job/job-invoice-api.js'
import UserBranchDropdown from '@/components/Shared/UserBranchDropdown'
import JobInvoice from './JobInvoice'
import numeral from 'numeral'
export default {
    name: 'ListJobInvoice',
    components: {
        UserBranchDropdown,
        JobInvoice
    },
    props:["pageCode"],
    data: () => ({
        headers: [
            {text: 'วันที่แจ้งซ่อม', value: 'jobDate'},
            {text: 'เลขที่ใบแจ้งซ่อม', value: 'jobNo'},
            {text: 'ทะเบียนรถ', value: 'licenseNo'},
            {text: 'เลขที่ใบประเมิน', value: 'estimateNo'},
            {text: 'ยอดใบประเมิน', value: 'estimateAmountDisplay'},
            {text: 'เลขที่ใบแจ้งหนี้', value: 'invoiceNo'},
            {text: 'ยอดใบแจ้งหนี้', value: 'invoiceAmountDisplay'},
            {text: 'Actions', value: 'action', sortable: false}
        ],
        items: [],
        branchCode: '',
        filter: ''
    }),
    methods: {
        setCurrentBranch(branchCode) {
            this.branchCode = branchCode;
            if (!this.branchCode) return;
            this.search();
        },
        search() {
            this.items = Object.assign([], []);
            this.$loading(true);

            listJobInvoice(this.branchCode).then(response => {
                this.items = response;
                if (this.items && this.items.length > 0) {
                    this.items.forEach(o => {
                        o.estimateAmountDisplay = numeral(o.estimateAmount).format('0,0.00');
                        o.invoiceAmountDisplay = numeral(o.invoiceAmount).format('0,0.00');
                    });
                }
                this.$loading(false);
            }).catch(() => {
                this.$loading(false);
            });
        },
        editJob(item) {
            this.$router.push({name: "edit-job", params: {branchCode: this.branchCode, jobId: item.jobId}});
        }
    }
}
</script>